import React, { useMemo } from "react"
import { useSelector } from "react-redux"
import { IAppState } from "../../../app/appTypes"
import { getTeamMembersByTeamIds } from "../../selectors/team"
import NameUser from "../names/NameUser"

interface IProps {
  teamIds: string[]
  header: string
}

const TeamMemberList: React.FC<IProps> = (props: IProps): JSX.Element => {
  const teamIds = useMemo(() => props.teamIds ?? [], [props.teamIds?.join(",")])
  const sortedUsers = useSelector((state: IAppState) => getTeamMembersByTeamIds(state, teamIds))

  if (!sortedUsers || sortedUsers.length === 0) return null

  const maxH = sortedUsers.length > 20 ? "max-h-64" : "max-h-32"
  return (
    <div>
      <div className="mb-2">{props.header}</div>
      <div className={`flex flex-col flex-wrap ${maxH} place-content-start overflow-auto mb-6`}>
        {sortedUsers.map((user) => <div className="w-1/6 mb-1" key={user.id}><NameUser firstName={user.firstName} lastName={user.lastName} isPending={user.pending} /></div>)}
      </div>
    </div>
  )
}

export default TeamMemberList
